
import dayjs, { Dayjs } from 'dayjs';
import { ActivityLog } from '../objects/events/loadEvents';

type BrokerRequest = {
    transactionDate: string;
    environment: string;
    application: string;
    customer: string;
    action: string;
    messageBody: string;
}

type BrokerNote = {
    recordKey: string;
    department: string;
    addedBy: string;
    noteBody: string;
    subject: string;
    isInternal: boolean;
}

type BrokerSuspense = {
    recordKey: string | null;
    department: string | null;
    assignedTo: string | null;
    createdBy: string | null;
    message: string | null;
}

type BrokerActivity = {
    activityMessage: string
}

export class MessageBroker {
    brokerApi = "";
    baseApi = "";
    loginApi = "";

    constructor() {
        this.baseApi = process.env.REACT_APP_BASE_APIV2_URL ?? "";
        this.brokerApi = (process.env.REACT_APP_API_MESSAGE_BROKER ?? "");
        this.loginApi = this.baseApi + "login";
    }

    async sendActivityAsync(log: ActivityLog) {
        if((log.recordKey === "" || log.recordKey === undefined || log.recordKey === null) && log.action !== "error_activity"){
            return;
        }

        var requestObject = { username: process.env.REACT_APP_APIV2_USERNAME, password: process.env.REACT_APP_APIV2_PASSWORD };
        var json = JSON.stringify(requestObject);

        var brokerMessage: BrokerRequest = {
            transactionDate: log.transactionDate,
            environment: process.env.REACT_APP_ENV ?? "",
            application: "ford-ui",
            customer: process.env.REACT_APP_CUSTOMER ?? "",
            action: log.action,
            messageBody: JSON.stringify({
                recordKey: log.recordKey,
                department: "UNDERWRITING",
                addedBy: "ford-ui",
                message: log.message,
                subject: log.subject,
                isInternal: true,
                isException: log.isException,
                error:log.error,
                level: log.level
            })
        };

        var brokerJson = JSON.stringify(brokerMessage);

        return fetch(this.brokerApi,
            {
                mode: "cors",
                method: "POST",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    "Content-Type": "application/json",
                    // "Authorization": "Bearer " + token
                },
                body: brokerJson
            });
    }

}